import { Component, OnInit, ChangeDetectionStrategy, inject, DOCUMENT } from '@angular/core';
import { WindowService } from '@shared/window';
import { RouterLink } from '@angular/router';
import { LocalizePipe } from '../../../i18n/pipes/lozalize.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, LocalizePipe, TranslatePipe],
})
export class PrivacyPolicyComponent implements OnInit {
    private document = inject(DOCUMENT);
    private windowService = inject(WindowService);

    ngOnInit(): void {
        this.windowService.scrollTo(0);
    }

    get currentDomain(): string {
        return this.document.location.origin;
    }
}
